import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { formatISO } from 'date-fns';
import { Field } from '@/models/card/CardModel';

const DayPicker = ({
  field,
  disabled,
  handleChange,
  error,
  ...other
}: {
  field: Field;
  disabled: boolean;
  handleChange: (id: string, value: any) => void;
  error: string;
  other: any;
}) => {
  return (
    <MuiDatePicker
      disabled={disabled}
      displayWeekNumber
      slotProps={{ textField: { variant: 'standard', error: !!error, helperText: error } }}
      label={field.name}
      name={field.id}
      onChange={(value) => {
        handleChange(field.id, value ? formatISO(value, { representation: 'date' }) : null);
      }}
      {...other}
    />
  );
};

export default DayPicker;
